import { MODULES } from '../module-ids';

/** System modules that are always enabled — cannot be disabled by users */
export const SYSTEM_MODULES: string[] = [MODULES.CORE, MODULES.ACCOUNTING];
